import { createContext } from 'react'

export const WorkspaceSlugContext = createContext<string>(null!)
